import convert from 'xml-js';

import { IEscrowMember } from '../../types/Parties';
import { IAddress } from './../../types/Address';
import { IXmlToJson } from './../../types/Files';

/**
 * TODO:
 * - fix @ts-ignore
 */

export const threeFourParser = (xmlFile: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function () {
      // @ts-ignore
      const data = convert.xml2json(this.result, { compact: true, spaces: 4 });
      let deal;
      if (JSON.parse(data)?.DOCUMENT_REQUEST) {
        deal =
          JSON.parse(data)?.DOCUMENT_REQUEST?.EMORTGAGE_PACKAGE?.MESSAGE
            ?.DEAL_SETS?.DEAL_SET?.DEALS?.DEAL;
      }
      if (JSON.parse(data)?.LQBDocumentRequest) {
        deal =
          JSON.parse(data)?.LQBDocumentRequest?.LoanData?.MESSAGE?.DEAL_SETS
            ?.DEAL_SET?.DEALS?.DEAL;
      }
      if (JSON.parse(data)?.MESSAGE) {
        deal = JSON.parse(data)?.MESSAGE?.DEAL_SETS?.DEAL_SET?.DEALS?.DEAL;
      }
      if (!deal) {
        reject(new Error('Could not parse file'));
        return;
      }
      const parties = deal?.PARTIES.PARTY;
      const extract: IXmlToJson = {
        signers: [],
        escrowTeam: [],
        properties: [],
        lenderName: '',
        loanPurpose: '',
        loanNumber: '',
      };
      const escrowPartyTypes = ['LoanOriginator'];
      const signerPartyTypes = ['Borrower']; // Buyer/Borrower
      const legalPartyTypes = ['LoanOriginationCompany'];

      // Gather Party Information
      if (parties && parties.length > 0) {
        for (let i = 0; i < parties.length; i++) {
          const roles = parties[i].ROLES.ROLE;
          const isArray = Array.isArray(roles);
          if (isArray) {
            for (let i2 = 0; i2 < roles.length; i2++) {
              if (
                signerPartyTypes.includes(
                  roles[i2]?.ROLE_DETAIL?.PartyRoleType?._text
                )
              ) {
                const signer: any = getSignerDetails(parties[i]);
                signer.Id = `import_${i}`;
                signer.SignerType = 'Buyer/Borrower';
                extract.signers?.push(signer);
              }
              if (
                escrowPartyTypes.includes(
                  roles[i2]?.ROLE_DETAIL?.PartyRoleType?._text
                )
              ) {
                const agent: IEscrowMember = getEscrowParty(parties[i]);
                agent.Id = `import_${i}`;
                extract.escrowTeam?.push(agent);
              }
              if (
                legalPartyTypes.includes(
                  roles[i2]?.ROLE_DETAIL?.PartyRoleType?._text
                )
              ) {
                const legalEntity =
                  parties[i]?.LEGAL_ENTITY?.LEGAL_ENTITY_DETAIL?.FullName
                    ?._text;
                extract.lenderName = legalEntity;
              }
            }
          } else {
            if (
              signerPartyTypes.includes(
                roles?.ROLE_DETAIL?.PartyRoleType?._text
              )
            ) {
              const signer: any = getSignerDetails(parties[i]);
              signer.Id = `import_${i}`;
              signer.SignerType = 'Buyer/Borrower';
              extract.signers?.push(signer);
            }
            if (
              escrowPartyTypes.includes(
                roles?.ROLE_DETAIL?.PartyRoleType?._text
              )
            ) {
              const agent: IEscrowMember = getEscrowParty(parties[i]);
              agent.Id = `import_${i}`;
              extract.escrowTeam?.push(agent);
            }
            if (
              legalPartyTypes.includes(roles?.ROLE_DETAIL?.PartyRoleType?._text)
            ) {
              const legalEntity =
                parties[i]?.LEGAL_ENTITY?.LEGAL_ENTITY_DETAIL?.FullName?._text;
              extract.lenderName = legalEntity;
            }
          }
        }
      }

      // Loan Details
      const loanIdentifiers = getLoanIdentifiers(deal?.LOANS?.LOAN);
      extract.properties = getPropertyDetails(
        deal?.COLLATERALS?.COLLATERAL?.SUBJECT_PROPERTY?.ADDRESS
      );
      extract.loanPurpose = loanIdentifiers?.loanPurpose;
      extract.loanNumber = loanIdentifiers?.loanNumber;
      extract.fileName = xmlFile.name;
      extract.fileType = '3.4';

      if (extract) {
        resolve(extract);
      } else {
        reject(new Error('unsupported file'));
      }
    };
    reader.readAsText(xmlFile);
  });
};

export const getLoanIdentifiers = (loans: any) => {
  const isArray = Array.isArray(loans);
  const loanIdentifiers = {
    loanPurpose: '',
    loanNumber: '',
  };

  const getLenderLoanNumber = (identifiers: any) => {
    const isArray = Array.isArray(identifiers);

    if (isArray) {
      for (let i = 0; i < identifiers.length; i++) {
        if (identifiers[i]?.LoanIdentifierType._text === 'LenderLoan') {
          return identifiers[i]?.LoanIdentifier?._text;
        }
      }
    } else {
      return identifiers?.LoanIdentifier?._text;
    }
    return '';
  };
  if (isArray) {
    for (let i = 0; i < loans.length; i++) {
      if (loans[i]?._attributes?.LoanRoleType === 'SubjectLoan') {
        loanIdentifiers.loanPurpose =
          loans[i]?.TERMS_OF_LOAN?.LoanPurposeType?._text;
        loanIdentifiers.loanNumber = getLenderLoanNumber(
          loans[i]?.LOAN_IDENTIFIERS?.LOAN_IDENTIFIER
        );
        return loanIdentifiers;
      }
    }
  } else {
    loanIdentifiers.loanPurpose = loans?.TERMS_OF_LOAN?.LoanPurposeType?._text;
    loanIdentifiers.loanNumber = getLenderLoanNumber(
      loans?.LOAN_IDENTIFIERS?.LOAN_IDENTIFIER
    );
    return loanIdentifiers;
  }
};

export const getPropertyDetails = (subjectProperty: any) => {
  if (subjectProperty) {
    const data = subjectProperty;
    const prop = [
      {
        Addresses: [
          {
            Line1: data?.AddressLineText?._text,
            Line2: '',
            Line3: '',
            State: {
              Name: data?.StateName?._text,
              Code: data?.StateCode?._text,
            },
            ZipCode: data?.PostalCode?._text,
            City: data?.CityName?._text,
            County: data?.CountyName?._text,
            Type: null,
          } as IAddress,
        ],
        PropertyType: '',
      },
    ];
    return prop;
  }
};

export const getSignerDetails = (party: any) => {
  const data = party.INDIVIDUAL;
  const contactPoints = data?.CONTACT_POINTS?.CONTACT_POINT;
  let partyType = '';
  const roles = party?.ROLES?.ROLE;
  const isArray = Array.isArray(roles);
  if (isArray) {
    for (let i = 0; i < roles.length; i++) {
      if (roles[i]?.BORROWER) {
        partyType = party?.ROLES?.ROLE[i]?.ROLE_DETAIL?.PartyRoleType?._text;
      }
    }
  } else {
    partyType = party?.ROLES?.ROLE?.ROLE_DETAIL?.PartyRoleType?._text;
  }

  const partyObj = {
    FirstName: data?.NAME?.FirstName?._text ? data.NAME.FirstName._text : '',
    MiddleName: data?.NAME?.MiddleName?._text ? data.NAME.MiddleName._text : '',
    LastName: data?.NAME?.LastName?._text ? data.NAME.LastName._text : '',
    SSN: party?.TAXPAYER_IDENTIFIERS?.TAXPAYER_IDENTIFIER
      ?.TaxpayerIdentifierValue?._text
      ? party?.TAXPAYER_IDENTIFIERS?.TAXPAYER_IDENTIFIER
          ?.TaxpayerIdentifierValue?._text
      : '',
    SignerType: partyType,
    Addresses: [],
    PhoneNumbers: contactPoints ? getPhoneNumbers(contactPoints) : [],
    Emails: contactPoints ? getEmails(contactPoints) : [],
    PrincipalType: 'Individual',
  };
  return partyObj;
};

export interface IEscrowMemberCustom extends IEscrowMember {
  PrincipalType?: string;
}

export const getEscrowParty = (party: any) => {
  const partyObj: IEscrowMemberCustom = {
    Id: '',
    FirstName: '',
    LastName: '',
    Type: '',
    Addresses: [],
    PhoneNumbers: [],
    Emails: [],
    PrincipalType: '',
  };
  // const partyType = party.ROLES?.ROLE?.ROLE_DETAIL?.PartyRoleType?._text
  const partyType = 'Loan Officer';
  if (party?.INDIVIDUAL) {
    const data = party.INDIVIDUAL;
    const contactPoints = data?.CONTACT_POINTS?.CONTACT_POINT;
    partyObj.FirstName = data?.NAME?.FirstName?._text
      ? data.NAME.FirstName._text
      : '';
    partyObj.LastName = data?.NAME?.LastName?._text
      ? data.NAME.LastName._text
      : '';
    partyObj.Type = partyType;
    partyObj.Addresses = [];
    partyObj.PhoneNumbers = contactPoints ? getPhoneNumbers(contactPoints) : [];
    partyObj.Emails = contactPoints ? getEmails(contactPoints) : [];
    partyObj.PrincipalType = 'Legal Entity';
    return partyObj;
  }
  if (party?.LEGAL_ENTITY) {
    const data = party.LEGAL_ENTITY;
    const contactPoints =
      data?.CONTACTS?.CONTACT?.CONTACT_POINTS?.CONTACT_POINT;
    partyObj.FirstName = data?.LEGAL_ENTITY_DETAIL?.FullName?._text
      ? data.LEGAL_ENTITY_DETAIL.FullName._text
      : '';
    partyObj.LastName = '';
    partyObj.Type = partyType;
    partyObj.Addresses = [];
    partyObj.PhoneNumbers = contactPoints ? getPhoneNumbers(contactPoints) : [];
    partyObj.Emails = contactPoints ? getEmails(contactPoints) : [];
    partyObj.PrincipalType = 'Legal Entity';
    return partyObj;
  }
  return partyObj;
};

export const getPhoneNumbers = (data: any) => {
  const isArray = Array.isArray(data);
  const array = [];

  if (!isArray) {
    const value =
      data?.CONTACT_POINT_TELEPHONE?.ContactPointTelephoneValue?._text;
    const type = data?.CONTACT_POINT_DETAIL?.ContactPointRoleType?._text;
    if (value && value.length === 10) {
      const obj = {
        CountryCode: '1',
        AreaCode: value?.substring(0, 3),
        Number: value?.substring(2, 9),
        Extension: null,
        Type: !type ? 'Cellular' : type,
      };
      array.push(obj);
    }
    return array;
  }
  for (let i = 0; i < data.length; i++) {
    const value =
      data[i]?.CONTACT_POINT_TELEPHONE?.ContactPointTelephoneValue?._text;
    const type = data[i]?.CONTACT_POINT_DETAIL?.ContactPointRoleType?._text;
    if (value && value.length === 10) {
      const obj = {
        CountryCode: '1',
        AreaCode: value?.substring(0, 3),
        Number: value?.substring(2, 9),
        Extension: null,
        Type: !type ? 'Cellular' : type,
      };
      array.push(obj);
    }
  }
  return array;
};

export const getEmails = (data: any) => {
  const isArray = Array.isArray(data);
  const array = [];

  if (!isArray) {
    const value = data?.CONTACT_POINT_EMAIL?.ContactPointEmailValue?._text;
    if (value) {
      array.push(value);
    }
    return array;
  }
  for (let i = 0; i < data.length; i++) {
    const value = data[i]?.CONTACT_POINT_EMAIL?.ContactPointEmailValue?._text;
    if (value) {
      array.push(value);
    }
  }
  return array;
};
